/* src/app/shared/shop/qty-stepper/qty-stepper.component.scss */
:host {
  display: contents;
}
.card-style ion-button {
  border: 1px solid #949494;
  padding: 0;
  border-radius: 5px;
}
.card-style ion-button::part(native) {
  background-color: transparent;
  height: 25px;
}
.card-style ion-button::part(native):hover {
  background-color: transparent;
}
.card-style ion-button.white::part(native) {
  background-color: transparent;
}
.card-style ion-icon {
  height: 25px;
  width: 25px;
  --background: transparent;
}
.card-style .buttons-container {
  gap: 0.2rem;
}
.card-style .buttons-container > * {
  margin-right: 0.2rem;
}
.card-style .buttons-container > :last-child {
  margin-right: 0;
}
.configurator-style ion-button {
  border-radius: 10px 5px 5px 10px;
  border: 1px solid var(--Blanco-y-negro-GRIS-2, #cbcbcb);
  background: var(--Blanco-y-negro-GRIS-1, #f6f6f6);
  display: flex;
  height: 45px;
  padding: 10px 15px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
.configurator-style ion-button:hover {
  border: 2px solid var(--ion-color-primary);
}
.configurator-style ion-button::part(native) {
  background-color: transparent;
}
.configurator-style ion-button::part(native):hover {
  background-color: transparent;
}
.configurator-style ion-button.white::part(native) {
  background-color: transparent;
}
.configurator-style ion-button.reduced {
  padding: 1px 6px;
}
.configurator-style ion-button.stepper-right {
  border-radius: 5px 10px 10px 5px;
}
.configurator-style ion-button.stepper-left {
  border-radius: 10px 5px 5px 10px;
}
.configurator-style ion-icon {
  transform: scale(1.5);
  --background: transparent;
}
.configurator-style ion-button.stepper-button:hover {
  box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.3);
  border: 2px solid #949494;
}
.configurator-style ion-button.stepper-button:focus {
  border-color: var(--ion-color-primary);
}
.configurator-style .showQty {
  background-color: transparent;
}
.configurator-style .disabled::part(native) {
  background-color: transparent !important;
}
.configurator-style .button-product-card ion-button::part(native) {
  background-color: transparent;
}
.configurator-style .button-product-card ion-button::part(native):hover {
  background-color: transparent;
}
.configurator-style .button-product-card .showQty-product-card {
  background-color: transparent;
}
.configurator-style .buttons-container {
  gap: 0.2rem;
}
.configurator-style .buttons-container > * {
  margin-right: 0.2rem;
}
.configurator-style .buttons-container > :last-child {
  margin-right: 0;
}
.default-style:not(.no-full-width) {
  width: 100%;
}
.default-style ion-button {
  min-height: 0;
}
.default-style ion-button:first-of-type::part(native) {
  border-radius: 10px 5px 5px 10px;
}
.default-style ion-button:last-of-type::part(native) {
  border-radius: 5px 10px 10px 5px;
}
.default-style ion-button::part(native) {
  background-color: #f6f6f6;
  border: 2px solid #cbcbcb;
  width: 45px;
  height: 44px;
}
.default-style ion-button.white::part(native) {
  background-color: transparent;
}
.default-style ion-icon {
  width: 18px;
  height: 18px;
  color: black;
}
.default-style .showQty {
  background-color: #f6f6f6;
  width: 100%;
  padding: 5px 15px;
  border-radius: 5px;
  font-family: "Barlow Semi Condensed";
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: #259dff;
}
.default-style .disabled::part(native) {
  background-color: transparent !important;
}
.default-style .button-product-card ion-button::part(native) {
  background-color: transparent;
}
.default-style .button-product-card ion-button::part(native):hover {
  background-color: transparent;
}
.default-style .button-product-card .showQty-product-card {
  background-color: transparent;
}
.default-style .buttons-container {
  gap: 3px;
  height: 45px;
}
ion-button {
  margin: 0;
  min-height: unset;
  aspect-ratio: 1/1;
}
ion-button::part(native) {
  padding-inline-start: 0;
  padding-inline-end: 0;
  padding: 2.5px;
  width: 20px;
  height: 28px;
  background-color: #f6f6f6;
}
ion-button::part(native):hover {
  background-color: #d4ecff;
}
ion-button:first-of-type {
  border-right: none;
  --border-radius: 5px 0 0 5px;
}
ion-button:last-of-type {
  --border-radius: 0 5px 5px 0;
}
ion-button.white::part(native) {
  background-color: white;
}
ion-icon {
  width: 14px;
  height: 14px;
  color: black;
}
.showQty {
  color: #43c0f6;
  font-family: "League Spartan", sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  background-color: #f6f6f6;
  padding: 2px 10px 2px 10px;
  width: 40px;
}
.disabled::part(native) {
  background-color: #f6f6f6 !important;
}
.showQty span {
  margin: 0;
}
@media only screen and (max-width: 1104px) {
  .showQty {
    font-size: 18px;
    font-weight: 600;
    text-align: center;
  }
}
@media only screen and (max-width: 997px) {
  .showQty {
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    width: 100%;
    max-width: 250px;
  }
}
.button-product-card {
  width: 100%;
  height: 40px;
}
.button-product-card ion-button {
  width: 33%;
  --border-color: #cbcbcb !important;
  --border-style: solid !important;
  --border-width: 1px !important;
}
.button-product-card ion-button::part(native) {
  max-width: 125px;
  width: 100%;
  height: 100%;
  padding: 5px;
  background-color: white;
  border-width: 1px;
}
.button-product-card ion-button::part(native):hover {
  background-color: #ffd5eb !important;
}
.button-product-card ion-button:first-of-type {
  border-right: none;
}
.button-product-card ion-button:first-of-type::part(native) {
  border-radius: 10px 0 0 10px;
}
.button-product-card ion-button:last-of-type {
  border-left: none;
}
.button-product-card ion-button:last-of-type::part(native) {
  border-radius: 0 10px 10px 0;
}
.button-product-card .showQty-product-card {
  width: 33%;
  color: #ff007f;
  background-color: white;
  border: 1px solid #cbcbcb;
  border-radius: 0;
  border-right: none;
  border-left: none;
  font-size: 18px;
}
.showQty-product {
  line-height: normal;
  width: 50px;
}
.qty-label {
  font-family: "Barlow Semi Condensed";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  color: black;
}
/*# sourceMappingURL=qty-stepper.component-74L7WAOM.css.map */
